import compose from "lodash/flowRight"
import PropTypes from "prop-types"
import withPath from "../path/withPath"

const withLesson = (ComposedComponent) => (props) =>
  (
    <ComposedComponent
      {...props}
      lesson={props.items.find(
        (item) => item.source_id === props.lessonSourceId
      )}
    />
  )

withLesson.displayName = "withLesson"

withLesson.contextTypes = {
  path: PropTypes.object
}

export default compose(withPath, withLesson)
